<ng-container *ngIf="item; else skeleton">
  <a [href]="domain + '/' + url" (click)="onClickItem(); $event.preventDefault()">
    <div class="item-box" [style.padding-top]="100 / ratio + '%'">
      <div class="item-con">
        <!-- 图片 -->
        <app-lazy-image [lazy]="[item.dayLogo, item.nightLogo]"></app-lazy-image>
      </div>
    </div>
  </a>
</ng-container>
<ng-template #skeleton>
  <div class="item-box skeleton-loading" [style.padding-top]="100 / ratio + '%'"></div>
</ng-template>
